import { render, staticRenderFns } from "./GenerarPDFVehiculosGeneral.vue?vue&type=template&id=215f5dad&"
import script from "./GenerarPDFVehiculosGeneral.vue?vue&type=script&lang=js&"
export * from "./GenerarPDFVehiculosGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports